// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_weight.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_weight',
	field: function() { return 'g.game_weight_avg' }
})
